import { Component, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrl: './spinner.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent {
    type = input<'infinitform' | 'simple'>('infinitform');
    size = input<'sm' | 'md' | 'lg'>('md');
}
